import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  // Check karein user login hai ya nahi
  const isAuth = sessionStorage.getItem("isAuth"); 

  if (!isAuth) {
    // Agar login nahi hai, to Login page par bhej do
    return <Navigate to="/login" replace />;
  }

  // Agar login hai, to page dikhao
  return children;
};

export default ProtectedRoute;